import axios from 'axios'

const apiCobro = 'facturacion-cobros/php/api/'

export default {
	buscar (datos, descarga) {
		const form = _.clone(datos)
		form.FechaIni = (form.FechaIni) ? datos.FechaIni.getTime() / 1000 : null
		form.FechaFin = (form.FechaFin) ? datos.FechaFin.getTime() / 1000 : null
		form.descargar = descarga
		return axios.post(apiCobro + 'buscar-recibos.php', form)
	},

	set (datos) {
		return axios.post(apiCobro + 'set-cobro.php', datos)
	},

	get (reciboID) {
		return axios.get(apiCobro + 'get-recibo.php?ReciboID=' + reciboID)
	},

	getPermisos () {
		return axios.get(apiCobro + 'get-permisos.php')
	},

	getFormasDePago () {
		return axios.get(apiCobro + 'get-forma-pago.php')
	},

	getEmpresas () {
		return axios.get(apiCobro + 'get-listado-empresas.php')
	},

	getComisionAgente (AgenteID) {
		return axios.get(apiCobro + 'get-comision-agente.php?AgenteID=' + AgenteID)
	},

	pagarRecibo (datos) {
		return axios.post(apiCobro + 'pagar-recibo.php', datos)
	},

	eliminar (idCobro) {
		const datos = {
			ID_cobro: idCobro
		}

		return axios.post(apiCobro + 'del-cobro.php', datos)
	}
}



// WEBPACK FOOTER //
// ./src/modulos/facturacion-cobros/vue/services/api.js